import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AccessibilityModule } from '@fgb/portal-component-library/accessibility';
import { CartItemModule } from '@fgb/portal-component-library/src/lib/loyalty/cart-item';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { LanguageSelectorModule } from '@fgb/portal-component-library/src/lib/shared/language-selector';
import { LoyaltyIconModule } from '@fgb/portal-component-library/src/lib/shared/loyalty-icon';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { SharedModule } from 'src/app/shared/shared.module';
import { ClubModule } from '../club/club.module';
import { GuardianModule } from '../guardian/guardian.module';
import { UserModule } from '../user/user.module';
import { AccountNavComponent } from './components/account-nav/account-nav.component';
import { FloatingCartButtonComponent } from './components/floating-cart-button/floating-cart-button.component';
import { FooterComponent } from './components/footer/footer.component';
import { GameNavComponent } from './components/game-nav/game-nav.component';
import { MixedLoyaltyNavComponent } from './components/mixed-loyalty-nav/mixed-loyalty-nav.component';
import { MobileNavMenuComponent } from './components/mobile-nav-menu/mobile-nav-menu.component';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { NavigationIndicatorComponent } from './components/navigation-indicator/navigation-indicator.component';
import { PopupNotificationComponent } from './components/popup-notification/popup-notification.component';
import { TicketNavComponent } from './components/ticket-nav/ticket-nav.component';
import { MobileNavBarMemberCardComponent } from './mobile-nav-bar-member-card/mobile-nav-bar-member-card.component';
import { FantasyNavComponent } from './components/fantasy-nav/fantasy-nav.component';

@NgModule({
  declarations: [
    NavBarComponent,
    NavigationIndicatorComponent,
    FooterComponent,
    MixedLoyaltyNavComponent,
    AccountNavComponent,
    MobileNavMenuComponent,
    TicketNavComponent,
    PopupNotificationComponent,
    FloatingCartButtonComponent,
    MobileNavBarMemberCardComponent,
    FantasyNavComponent,
  ],
  exports: [
    NavBarComponent,
    NavigationIndicatorComponent,
    FooterComponent,
    MixedLoyaltyNavComponent,
    AccountNavComponent,
    GameNavComponent,
    MobileNavMenuComponent,
    TicketNavComponent,
    PopupNotificationComponent,
    FloatingCartButtonComponent,
    MobileNavBarMemberCardComponent,
    FantasyNavComponent,
  ],
  imports: [
    RouterModule,
    NgbModule,
    CommonModule,
    FormsModule,
    InlineSVGModule,
    SharedModule,
    UserModule,
    ClubModule,
    GuardianModule,
    LanguageSelectorModule,
    LoyaltyIconModule,
    CartItemModule,
    AccessibilityModule,
    FGBSharedModule,
    GameNavComponent,
  ],
})
export class LayoutModule {}
